import { UtilityOptions, PRODUCT_KEY } from "@opengov/components-nav-bar";
import { IntlShape } from "react-intl";

const BNP_HELP_CENTER_URL = "https://opengov.my.site.com/support/s/";
const RNT_HELP_CENTER_URL = "https://opengov.my.site.com/support/s/topic/0TO8X000000MheEWAS/reporting-transparency";
const IDEAS_URL = "https://ideas.opengov.com";
const CONTACT_SUPPORT_URL = "https://opengov.my.site.com/support/s/contactsupport";

export type GetHelpOptionsParams = {
  activeProductKey: PRODUCT_KEY | undefined;
  intl: IntlShape;
};

export const getHelpOptions = ({ activeProductKey, intl }: GetHelpOptionsParams): UtilityOptions => ({
  menuSections: [
    {
      menuItems: [
        {
          url: activeProductKey === "reporting" ? RNT_HELP_CENTER_URL : BNP_HELP_CENTER_URL,
          label: intl.formatMessage({ defaultMessage: "Help Center" }),
          description: intl.formatMessage({ defaultMessage: "Search for resources in OpenGov's Help Center" }),
          openInNewTab: true,
          dataOg: "help_center",
        },
        ...(activeProductKey === "reporting"
          ? []
          : [
              {
                url: IDEAS_URL,
                label: intl.formatMessage({ defaultMessage: "Ideas" }),
                description: intl.formatMessage({ defaultMessage: "Share your feedback with us" }),
                openInNewTab: true,
                dataOg: "ideas",
              },
            ]),
        {
          url: CONTACT_SUPPORT_URL,
          label: intl.formatMessage({ defaultMessage: "Contact Support" }),
          description: intl.formatMessage({ defaultMessage: "Connect with our team" }),
          openInNewTab: true,
          dataOg: "contact_support",
        },
      ],
    },
  ],
});
